export default __webpack_public_path__ + "locales/en/Payments.json?hash=a759eb89e7abce10fcfb88467ee97d19";